import React, { useCallback, useContext, useEffect } from 'react';
import { Box, Stack, useMediaQuery } from '@mui/material';
import { Link } from 'react-router-dom';
import { getLetters, getApplyToken } from '../../components/apis/music-api';
import { useMusicStore } from '../../components/store/store';
import { AuthenticationContext } from '../../components/authentication/AuthenticationContext';
import callApi from '../call-api/call-api';
import './Letters.scss';

const Letters = () => {
  const { isAuthenticated, getAccessToken } = useContext(AuthenticationContext);
  const { alphaNumericGroups, setLetters } = useMusicStore();
  const isSmall = useMediaQuery('(max-width:1000px)');
  const applyToken = useCallback(async () => await getApplyToken(getAccessToken()), [getAccessToken]);

  useEffect(() => {
    if (isAuthenticated()) {
      applyToken();
    }
  }, [isAuthenticated, applyToken])
  
  useEffect(() => {    
    if (isAuthenticated() && (alphaNumericGroups === undefined || alphaNumericGroups.length === 0)) {      
      callApi<string[]>(getLetters(getAccessToken()), setLetters);
    }
  }, [isAuthenticated, alphaNumericGroups, setLetters, getAccessToken]);

  return (
    <Stack 
      display="flex" 
      flexDirection="row" 
      flexWrap="wrap" 
      gap={0.5}
      justifyContent={isSmall ? 'center' : 'flex-start'}
      alignItems={isSmall ? 'center' : 'flex-start'}
      sx={{ padding: '8px' }}
    >
      <>
        {alphaNumericGroups?.filter(x => x !== 'Compilations').map((name: string, index: number) =>
            <Box className="letters" sx={{ whiteSpace: 'nowrap' }}><Link to={`/letters/${name}`} className='letters-link'>{name}</Link></Box>
        )}
        <Box className="letters"><Link to={`/compilations`} className='letters-link'>Compilations</Link></Box>
        <Box className="letters"><Link to={`/playlists`} className='letters-link'>Playlists</Link></Box>
      </>
    </Stack>
  )
}

export default Letters;